export default __webpack_public_path__ + "static/media/8.f597e7ae.jpg";